/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeListItemDto } from '../../models/employee-list-item-dto';
import { PaginatedDto } from '../../models/paginated-dto';

export interface EmployeeControllerFindAll$Params {
  firstName?: string;
  lastName?: string;
  email?: string;
  officeId?: number;
  page: number;
  limit: number;
  sortCol?: string;
  sortDir?: 'ASC' | 'DESC';
  deleted?: boolean;
}

export function employeeControllerFindAll(http: HttpClient, rootUrl: string, params: EmployeeControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDto & {
'items'?: Array<EmployeeListItemDto>;
}>> {
  const rb = new RequestBuilder(rootUrl, employeeControllerFindAll.PATH, 'get');
  if (params) {
    rb.query('firstName', params.firstName, {});
    rb.query('lastName', params.lastName, {});
    rb.query('email', params.email, {});
    rb.query('officeId', params.officeId, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortCol', params.sortCol, {});
    rb.query('sortDir', params.sortDir, {});
    rb.query('deleted', params.deleted, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDto & {
      'items'?: Array<EmployeeListItemDto>;
      }>;
    })
  );
}

employeeControllerFindAll.PATH = '/api/employee';
